import React from 'react';
import Button from '../../../components/common/ui-components/input/Button';
import styles from '../../../styles/modules/components/tracker.module.scss';
import { formatDate } from '../../../utils';
import { trackerClickTrack } from '../../../tracking/trackerTracking';
import Image from '../../common/Image';
import { useRouter } from 'next/router';
import { getIsAuthenticateCookie } from '../../../api/cookies';

const ChildSRStatusList = ({ category, children_sr }) => {
    return (
        <span className={`${styles.detail_value}`}>
            {
                children_sr.map((child, index) => {
                    let name = '';
                    if (child.device_details.brand) name += ` ${child.device_details.brand}`;
                    if (child.device_details.model) name += ` ${child.device_details.model}`;
                    if (!name && category) name = `${category || "Device"} ${index+1}`;
                    return (<span key={index} className={`${styles.detail_list_item__highlighted} ${styles.multi_child_status}`}>{name} - {child.current_status}</span>);
                })
            }
        </span>
    );
}

const SRListItem  = (props) => {
    const isAuthenticated = getIsAuthenticateCookie()
    const router = useRouter();
    let { ref_no ,last_updated, current_status ,created ,device_details, display_service_type, is_child_sr, is_parent_sr, children_sr = [], is_address_verified, is_address_verification__expired} = props;
    
    return(
        <li className={styles.list_item} tabIndex={0}>
            <label htmlFor={ref_no} className={styles.list_item_wrap}>    
                <div className={styles.details_wrap}>
                    <h4> { device_details.brand}  {device_details.category} ({display_service_type})</h4>
                    <div className={styles.details_box}>
                        <div className={styles.detail_list}>
                            {!is_child_sr && <div className={styles.detail_list_item}>
                                <span className={styles.detail_key}>Service Request ID</span>
                                <span className={styles.detail_value}>{ref_no}</span>
                            </div>}
                            <div className={styles.detail_list_item}>
                                <span className={styles.detail_key}>Request created on</span>
                                <span className={styles.detail_value}>{formatDate(created, "Do MMM, YYYY")}</span>
                            </div>
                            <div className={styles.detail_list_item}>
                                <span className={styles.detail_key}>Last updated on</span>
                                <span className={styles.detail_value}>{formatDate(last_updated, "Do MMM, YYYY")}</span>
                            </div>
                            <div className={styles.detail_list_item}>
                                <span className={styles.detail_key}>Status</span>
                                { (is_parent_sr && children_sr) ? <ChildSRStatusList children_sr={children_sr} category={device_details.category}/> :
                                    <span className={`${styles.detail_value} ${styles.detail_list_item__highlighted}`}>{ current_status}</span> }
                            </div>
                        </div>
                        <div className={styles.list_item__action}>
                            {!is_address_verified  && !is_address_verification__expired &&
                            (<>
                                <div className={styles.address_verification_warning}>
                                    <Image src="/static/images/warning_icon_16.png" width={16} height= {16}/>
                                    <p>Service Address not verified</p>
                                </div>
                                <Button text={"VERIFY ADDRESS"} className={styles.primary_button} onClick={() => {
                                    if (is_child_sr) trackerClickTrack({ label: 'TSR_Track now_child' })
                                    let url = `/selfserve/address/${ref_no}`
                                    isAuthenticated ? router.push(url) : router.push(`/login?next=${url}&from=otpLogin`)
                                }}/> 
                            </>
                            )
                            }
                            <Button text={"Track Now"} onClick={() => {
                                if (is_child_sr) trackerClickTrack({ label: 'TSR_Track now_child' })
                                props.action(ref_no);
                            }} 
                            variant = {is_address_verified  || is_address_verification__expired  ? 'primary' : 'secondary'}
                            className = {!is_address_verified  && !is_address_verification__expired && styles.secondary_button || 'tracker-btn'}
                            />
                        </div>
                    </div>
                </div>
            </label>
        </li>
    )
}

export default SRListItem;